import { ArrowForwardIos, ContentCopy, Delete, Videocam } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const link = process.env.REACT_APP_BACKEND_URL === "http://localhost:8090"
    ? "http://localhost:8090"
    : process.env.REACT_APP_BACKEND_URL;

  const storageItems = useNodeStorage();

  return
}
)